import clsx from "clsx";
import React from "react";

const PageSection = ({
  children,
  sectionName,
  subheading,
  descriptionText,
  className
}: {
  children: React.ReactNode;
  sectionName: string;
  subheading?: string;
  descriptionText?: string;
  className?: string; 

}) => (
  <div className={clsx("flex flex-col w-full mt-1 border-t", className)}>
    <div className="flex items-end pb-1 pt-5" >
      <h2 className="text-gray-600"> {sectionName} </h2>
      {subheading ? <p className="font-light pb-1">{subheading}</p> : null}
    </div>
    {descriptionText && <p>{descriptionText}</p>}
    {children}
  </div>
);

export default PageSection;
